module.exports = __webpack_public_path__ + "static/media/tick.33a1130d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/tick.png
// module id = 728
// module chunks = 0